(function () {
  'use strict';

  var MP4  = 'data-src-mp4';
  var WEBM = 'data-src-webm';

  function loadVideo(video) {
    if (video.dataset.bhLoaded) return;
    video.dataset.bhLoaded = '1';

    // WebM first (smaller file, modern browsers)
    var webm = video.getAttribute(WEBM);
    if (webm) {
      var sw = document.createElement('source');
      sw.src  = webm;
      sw.type = 'video/webm';
      video.appendChild(sw);
    }

    // MP4 fallback
    var mp4 = video.getAttribute(MP4);
    var sm  = document.createElement('source');
    sm.src  = mp4;
    sm.type = 'video/mp4';
    video.appendChild(sm);

    // Fade in once the browser has buffered enough to play
    video.addEventListener('canplay', function () {
      video.classList.add('bh-video--ready');
    }, { once: true });

    video.load();
    // play() returns a promise; silence the rejection if autoplay is blocked
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function observe(video) {
    // Start fetching 400 px before the section enters the viewport so it's
    // already buffered by the time the user sees it.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target);
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      io.observe(video);
    } else {
      loadVideo(video);
    }
  }

  function init() {
    document.querySelectorAll('.bh-video[' + MP4 + ']').forEach(observe);
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: section reloaded
  document.addEventListener('shopify:section:load', init);
})();
